const HOME_MARKUP = String.raw`<a class="announce" href="https://nas.com/momshiach/challenges/5-things-nobody-taught-you" target="_blank" rel="noopener noreferrer" data-testid="home-announcement-bar">🧅 Free 5-day kitchen challenge: 5 Things Nobody Taught You.<strong>Join free →</strong></a>
<header class="top">
  <div class="wrap">
    <nav aria-label="Main">
      <a class="brand" href="#top" data-testid="home-logo"><img src="/brand/logo-light.png" alt="Momshiach · Your Personal Redemption" width="160" height="49"></a>
      <div class="links">
        <a href="/energy-therapy" data-testid="home-nav-energy-therapy">Energy Therapy</a>
        <a href="/health-coaching" data-testid="home-nav-health-coaching">Health Coaching</a>
        <a href="/carebnb" data-testid="home-nav-carebnb">CareBnB</a>
        <a href="/workshops" data-testid="home-nav-workshops">Workshops</a>
        <a href="/resources" data-testid="home-nav-resources">Resources</a>
        <a href="/method" data-testid="home-nav-method">The Method</a>
      </div>
    </nav>
    <div class="hero" id="top">
      <span class="script">Your Personal Redemption</span>
      <h1>Come back to <em>yourself.</em></h1>
      <p class="lede">I'm Chanah Rothberg: mom of ten, chef, and Kosher Energy Therapist in Israel. Momshiach helps mothers make space for the woman behind the motherhood, through nourishing food, soul work, coaching and community.</p>
      <div class="ctas">
        <a class="btn primary" href="#ways-in">Find your way in</a>
        <a class="btn ghost" href="https://nas.com/momshiach">Join the community</a>
        <a class="btn ghost" href="/method" data-testid="home-method-btn">See the Momshiach Method</a>
      </div>
      <div class="roles" aria-label="Chanah's roles">
        <span>Chef Raw Raw</span><span>OrBach Energy</span><span>Health Coach</span><span>Narrative Therapist</span><span>CareBnB Israel</span>
      </div>
    </div>
  </div>
</header>

<main>
  <section class="challenge" data-testid="home-challenge-banner">
    <div class="wrap challenge-inner">
      <div class="challenge-copy">
        <span class="challenge-eyebrow">Free 5-Day Kitchen Challenge</span>
        <h2>Feeding everyone else? Your turn.</h2>
        <p>Simple kitchen basics in videos under 2 minutes. On your own time. No question too basic.</p>
      </div>
      <a class="challenge-btn" href="https://nas.com/momshiach/challenges/5-things-nobody-taught-you" target="_blank" rel="noopener noreferrer" data-testid="home-challenge-btn">Start the free challenge</a>
    </div>
  </section>

  <section id="story">
    <div class="wrap story">
      <div>
        <span class="eyebrow">My story</span>
        <h2>Six children overnight. Then ten. Then finding my way back.</h2>
        <div class="prose">
          <p>Before motherhood I ran clean food cafés in Jerusalem, where people knew me as Chef Raw Raw. I was living as the healthiest, most connected version of myself.</p>
          <p>Right before COVID, I married a man with six children and became their full-time mother overnight. We had four more. Ten children, a new city and a new religious life, all within a couple of years. Somewhere in the middle of it, I lost track of who I was.</p>
          <p>Food changed. My emotional world changed. I needed help and had no hour to spare for it. What brought me back was a mix of the things I already knew and a few I had to learn: feeding myself first, clearing the blocks I couldn't talk my way out of, and finding other women who understood.</p>
          <p>Momshiach is that path, made simple. No perfection and no extreme change. We gently add good into your life and remove what keeps you stuck.</p>
        </div>
      </div>
      <aside>
        <blockquote>If it's just for Mommy, they'll all want it.</blockquote>
        <ul class="creds">
          <li>Culinary arts degree, Johnson &amp; Wales University</li>
          <li>Integrative Nutrition Health Coach</li>
          <li>Certified Kosher Energy Therapist (Or Emuna)</li>
          <li>Narrative therapist and EFT practitioner</li>
          <li>Author of the cookbook <cite>Return to Your Roots</cite></li>
          <li>Over a decade living in Israel</li>
        </ul>
      </aside>
    </div>
  </section>

  <section id="ways-in" class="doors-band">
    <div class="wrap">
      <span class="eyebrow">Ways in</span>
      <h2>One woman, four doors</h2>
      <p class="doors-intro">Every part of my work does the same thing: it brings you back to yourself. Start with whichever door feels easiest today.</p>
      <div class="doors">
        <article class="door body">
          <span class="tag">Body</span>
          <h3>Chef Raw Raw: food that feeds you first</h3>
          <p>Colorful, plant-forward cooking for busy moms. When you nourish yourself, your kids follow.</p>
          <ul>
            <li><cite>Return to Your Roots</cite> cookbook</li>
            <li>Fridge Magic: master healthy eating for life</li>
            <li>Cookbook video companion course</li>
            <li>Plant-based lunches to go</li>
          </ul>
          <a class="go" href="https://nas.com/momshiach/products">See courses and the cookbook →</a>
        </article>
        <article class="door soul">
          <span class="tag">Soul</span>
          <h3>OrBach Energy: Kosher Energy Therapy</h3>
          <p>Private, remote sessions that clear what's in your way. You don't sit in a room. You listen to a short voice report. Open to everyone, not only moms.</p>
          <ul>
            <li>Initial session and full report, $250</li>
            <li>Free 15-minute call for the skeptical</li>
          </ul>
          <a class="go" href="https://www.orbachenergy.com/">Visit orbachenergy.com →</a>
        </article>
        <article class="door mind">
          <span class="tag">Mind</span>
          <h3>Health coaching and narrative therapy</h3>
          <p>One-on-one support to rewrite the story you tell about yourself and build simple habits you can keep.</p>
          <ul>
            <li>Integrative nutrition health coaching</li>
            <li>EFT tapping</li>
            <li>Momshiach live workshops for mothers</li>
          </ul>
          <a class="go" href="#contact">Ask about coaching →</a>
        </article>
        <article class="door place">
          <span class="tag">Place</span>
          <h3>CareBnB Israel: rest in Efrat</h3>
          <p>A self-care retreat home in Efrat for women who need a real pause, and for seminary girls who want a taste of Jewish home life.</p>
          <a class="go" href="#contact">Ask about retreat dates →</a>
        </article>
      </div>
    </div>
  </section>

  <section id="testimonials" data-testid="home-testimonials">
    <div class="wrap">
      <div class="t-head">
        <div>
          <span class="eyebrow">Kind words</span>
          <h2>What women are saying</h2>
        </div>
        <div class="t-nav">
          <button type="button" class="t-btn" data-dir="-1" aria-label="Previous testimonial" data-testid="home-testimonials-prev">←</button>
          <button type="button" class="t-btn" data-dir="1" aria-label="Next testimonial" data-testid="home-testimonials-next">→</button>
        </div>
      </div>
      <div class="t-track" tabindex="0" aria-label="Testimonials" data-testid="home-testimonials-track">
          <figure class="t-slide" data-testid="home-testimonial-1">
            <blockquote>After working with Chanah, I noticed a real sense of calm and balance in my day to day life. Her approach is gentle and intuitive, and the session left me feeling clearer and more centered. It's a subtle but meaningful shift that's made a difference for me.</blockquote>
            <figcaption><strong>Batsheva N.</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-2">
            <blockquote>You made it very simple. Sometimes it's so complicated in our heads, but it's not really complicated at all. I'm less worried, and more content, I'm not worried. It feels like ME.</blockquote>
            <figcaption><strong>Nechama Dukes</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-3">
            <blockquote>Chanah has helped me tremendously in moving past mental and emotional blockages, unhealthy thought and behavioral patterns which I have been holding on to for many years, some of them for a lifetime.</blockquote>
            <figcaption><strong>Batya R.</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-4">
            <blockquote>Chanah's heart hears and sees in a way that just 'gets it'. With a presence so available and super open to flow with you wherever it is you're going. So grateful to meet this gift along my journey!</blockquote>
            <figcaption><strong>C.K.</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-5">
            <blockquote>Chanah has a special way of making you feel seen and supported with gentleness and an emotional intuitiveness that is rare to find! Her deep care is felt immediately and her wisdom and life experience are extremely beneficial as a client.</blockquote>
            <figcaption><strong>S.W.</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-6">
            <blockquote>Everyone wants to feel heard, but not everyone understands that being heard begins with ourselves. Do we really understand all that is transpiring in our mind, heart and soul? In every generation, the Ribbono shel Olam places certain people, gifted with the ability to provide this gift for others. My dear friends, Chanah &amp; Pesach Rothberg, have dedicated their lives to create the space for the authentic soul seeker to understand the inner conversations of our true selves, and develop a healthy approach which is geared toward each person individually. Through working with them, one will be blessed to begin to experience sincere joy in becoming an Eved Hashem.</blockquote>
            <figcaption><strong>Rav Shlomo Katz</strong><span>Shirat David, Efrat</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-7">
            <blockquote>Received your cookbook and it has exceeded expectations! It is outstanding and brilliant!! Thanks so much 🌺</blockquote>
            <figcaption><strong>Orah S.F.</strong><span>Return to Your Roots</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-8">
            <blockquote>From someone who has shelves and shelves of cookbooks — I specifically love this one 🩵</blockquote>
            <figcaption><strong>Steph T.</strong><span>Return to Your Roots</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-9">
            <blockquote>I came to Israel looking for a hobby. I purchased your cookbook and it became my companion throughout the summer.</blockquote>
            <figcaption><strong>Yehudit</strong><span>Return to Your Roots</span></figcaption>
          </figure>
          <figure class="t-slide" data-testid="home-testimonial-10">
            <blockquote>This is more than just a cookbook, it's an experience.</blockquote>
            <figcaption><strong>Bina</strong><span>Return to Your Roots</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-1">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://drive.google.com/file/d/1NJnKDjYg0elNJRgvX5IxILSQb46MxYm6/preview" data-title="Energy Therapy video testimonial 1" aria-label="Play Energy Therapy video testimonial 1"><img src="https://drive.google.com/thumbnail?id=1NJnKDjYg0elNJRgvX5IxILSQb46MxYm6&amp;sz=w600" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-2">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://drive.google.com/file/d/1EeHo9aJLhv5Huud4innGBtr7viwTzuL3/preview" data-title="Energy Therapy video testimonial 2" aria-label="Play Energy Therapy video testimonial 2"><img src="https://drive.google.com/thumbnail?id=1EeHo9aJLhv5Huud4innGBtr7viwTzuL3&amp;sz=w600" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-3">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://drive.google.com/file/d/1JPaJ9bwqumi1-OlOITwbIQ7mgwiGWhPC/preview" data-title="Energy Therapy video testimonial 3" aria-label="Play Energy Therapy video testimonial 3"><img src="https://drive.google.com/thumbnail?id=1JPaJ9bwqumi1-OlOITwbIQ7mgwiGWhPC&amp;sz=w600" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-4">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://drive.google.com/file/d/1YG3nNKxjXaS8nl9M5kRAPw6l-2HWAVCJ/preview" data-title="Energy Therapy video testimonial 4" aria-label="Play Energy Therapy video testimonial 4"><img src="https://drive.google.com/thumbnail?id=1YG3nNKxjXaS8nl9M5kRAPw6l-2HWAVCJ&amp;sz=w600" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Energy Therapy</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-5">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://www.youtube.com/embed/MBhuvoONY4A?autoplay=1" data-title="Health Coaching video testimonial 5" aria-label="Play Health Coaching video testimonial 5"><img src="https://i.ytimg.com/vi/MBhuvoONY4A/hqdefault.jpg" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Health Coaching</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-6">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://www.youtube.com/embed/ql-ADypPEpY?autoplay=1" data-title="Health Coaching video testimonial 6" aria-label="Play Health Coaching video testimonial 6"><img src="https://i.ytimg.com/vi/ql-ADypPEpY/hqdefault.jpg" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Health Coaching</span></figcaption>
          </figure>
          <figure class="t-slide t-video" data-testid="home-video-testimonial-7">
            <div class="t-frame"><button type="button" class="t-play" data-src="https://drive.google.com/file/d/11iD9BD4MHQQ3vg8x4XDBpmtCzyYo542b/preview" data-title="Momshiach workshop video" aria-label="Play Momshiach workshop video"><img src="https://drive.google.com/thumbnail?id=11iD9BD4MHQQ3vg8x4XDBpmtCzyYo542b&amp;sz=w600" alt="" loading="lazy"><span class="t-play-icon" aria-hidden="true">▶</span></button></div>
            <figcaption><strong>Video story</strong><span>Workshops</span></figcaption>
          </figure>
      </div>
    </div>
  </section>

  <section id="community">
    <div class="wrap community">
      <div>
        <span class="eyebrow">Community</span>
        <h2>You don't have to find yourself alone</h2>
        <p>The Momshiach community gathers moms for live events, new content and a WhatsApp group where you can ask, share and be seen.</p>
      </div>
      <a class="btn" href="https://nas.com/momshiach">Join on nas.com</a>
    </div>
  </section>

  <section id="faq" class="doors-band">
    <div class="wrap">
      <span class="eyebrow">Questions</span>
      <h2>Common questions</h2>
      <div class="faq">
        <details open><summary>What is Momshiach?</summary><p>Momshiach is Chanah Rothberg's wellness community for mothers. It combines healthy cooking, Kosher Energy Therapy, coaching and live events to help moms keep their identity while raising their families.</p></details>
        <details><summary>Who is Chef Raw Raw?</summary><p>Chef Raw Raw is Chanah's culinary name from her raw food and clean food, plant-forward cafés in Jerusalem, Israel, and Whole Foods Market in Venice Beach, CA. Her cookbook and online courses carry that name.</p></details>
        <details><summary>Is OrBach Energy only for mothers?</summary><p>No. OrBach Energy is open to people of all backgrounds. "Kosher" describes the Torah-rooted practice, not who it's for.</p></details>
        <details><summary>Where are you based?</summary><p>Chanah lives in Israel. Courses, coaching and energy therapy are online. CareBnB retreats take place in Efrat.</p></details>
      </div>
    </div>
  </section>
</main>

<footer id="contact">
  <div class="wrap cols">
    <div>
      <strong>Momshiach</strong> · Chanah Rothberg<br>
      Email: <span class="addr">info@chefrawraw.com</span><br>
      Instagram: @momshiach
    </div>
    <div>
      <a href="https://www.orbachenergy.com/">OrBach Energy</a> ·
      <a href="https://nas.com/momshiach">Community &amp; courses</a>
    </div>
  </div>
</footer>
`;

export default HOME_MARKUP;
